<template>
  <div class="modal" v-if="visible">
    <div class="modal-position modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5>고객사 검색</h5>
          <button type="button" class="close" @click="clickCloseModal">×</button>
        </div>
        <div class="modal-body">
          <div class="d-flex">
            <div class="w-35per d-inline-block">
              <b-form-input id="name" v-model="companyName" type="text" placeholder="고객사명을 선택해주세요." @keyup.enter="search"></b-form-input>
            </div>
            <b-button variant="primary" class="ms-2" @click="search">검색</b-button>
          </div>
          <div class="d-flex mt-3">
            <div class="w-100per">
              <table id="dtHorizontalExample" class="table table-bordered table-hover h-300px y-scroll" cellspacing="0" width="100%">
                <thead class="w-100per d-inline-block table-light">
                  <tr class="w-100per d-inline-block">
                    <th class="w-100per d-inline-block txt-center">고객사</th>
                  </tr>
                </thead>
                <tbody class="w-100per d-inline-block">
                  <template v-if="companyList.length > 0 && !loading">
                    <tr class="w-100per d-inline-block" v-for="(item, index) in companyList" :key="'company' + index">
                      <td class="w-100per d-inline-block txt-center cursor" @click="rowSelect(item)">{{ item.kname }}</td>
                    </tr>
                  </template>
                  <template v-else-if="loading">
                    <tr class="w-100per d-inline-block">
                      <td colspan="99" class="w-100per d-inline-block txt-center">
                        <font-awesome-icon icon="fa-solid fa-spinner" spin />
                      </td>
                    </tr>
                  </template>
                  <tr v-else class="w-100per d-inline-block">
                    <td class="w-100per d-inline-block txt-center">검색결과가 없습니다.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, ref, watch } from '@vue/runtime-core';
import { companyListApi } from '@/api/integrateapi';
export default {
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['closeModal', 'selectModal'],
  setup(props, cotext) {
    let companyList = reactive([]);
    const companyName = ref('');
    const loading = ref(false);
    const clickCloseModal = () => {
      cotext.emit('closeModal');
    };

    const search = () => {
      if (companyName.value.length < 2) {
        alert('2자 이상 입력해주세요.');
        return false;
      }
      apiComapnyList();
    };

    const apiComapnyList = () => {
      loading.value = true;
      companyListApi(companyName.value)
        .then(resp => {
          companyList.length = 0;
          const { data: respData } = resp.data;

          const { list } = respData;
          list.forEach(item => {
            companyList.push(item);
          });
        })
        .catch(error => {
          if (error.response) {
            alert('서버에 에러가 발생하였습니다.');
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.log(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.log('Error', error.message);
          }
          console.log(error.config);
        })
        .finally(() => {
          loading.value = false;
        });
    };

    const rowSelect = item => {
      cotext.emit('selectModal', item);
    };

    watch(
      () => props.visible,
      cur => {
        if (cur) {
          companyName.value = '';
          companyList.length = 0;
        }
      }
    );

    return {
      companyName,
      companyList,
      loading,
      search,
      clickCloseModal,
      rowSelect,
    };
  },
};
</script>

<style></style>
